import React from 'react';
import { Form, Card, Button, Upload } from 'antd';
import { connect } from 'dva';
import { formItemLayout } from 'utils/utils.js';
import { urlCollect } from 'services/service-utils.js';
import UploadImage from 'components_business/UploadImage/Index.js';
import styles from './Index.less';

const FormItem = Form.Item;

const getInitialValue = (key, value) => {
  const ret = value[key];
  return ret ? [ret] : [];
};

const getUploadValue = value => (Array.isArray(value) ? value[0] : value);

@connect(({ loading, operationMerchantAddOrUpdate }) => ({
  submitting: loading.effects['operationMerchantAddOrUpdate/addOrUpdateMerchantBaseInfo'],
  merchantId: operationMerchantAddOrUpdate.merchantId,
  baseInfoFormData: operationMerchantAddOrUpdate.baseInfoFormData,
  loading: loading.effects['operationMerchantAddOrUpdate/fetchBaseInfo'],
}))
@Form.create()
export default class BaseIn extends React.Component {
  constructor(props) {
    super(props);

    // 供表单验证规则使用
    this.baseInfoDocForValidator = [];
    this.state = {
      excelFileUrl: getInitialValue('excelFileUrl', props.baseInfoFormData),
      excelFile: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { form, baseInfoFormData, merchantIdForEditOrQuery, type } = this.props;

    if (type === 'add') {
      form.setFieldsValue(baseInfoFormData);
    } else if (type === 'edit' || type === 'query') {
      this.props.dispatch({
        type: 'operationMerchantAddOrUpdate/fetchBaseInfo',
        merchantId: merchantIdForEditOrQuery,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.baseInfoFormData.excelFileUrl && nextProps.baseInfoFormData.excelFileUrl) {
      this.setState({
        excelFileUrl: getInitialValue('excelFileUrl', nextProps.baseInfoFormData),
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const { form, successCallback, dispatch, merchantId } = this.props;
    const { excelFile } = this.state;

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const baseInfoFormData = {
          excelFile,
          operationLicenseUrl: getUploadValue(values.operationLicenseUrl),
          specificAptitudeUrl: getUploadValue(values.specificAptitudeUrl),
          schoolLicenseUrl: getUploadValue(values.schoolLicenseUrl),
          businessLicenseUrl: getUploadValue(values.businessLicenseUrl),
          organizationCodeCertificateUrl: getUploadValue(values.organizationCodeCertificateUrl),
          identityFrontUrl: getUploadValue(values.identityFrontUrl),
          identityReverseUrl: getUploadValue(values.identityReverseUrl),
        };

        dispatch({
          type: 'operationMerchantAddOrUpdate/addOrUpdateMerchantBaseInfo',
          baseInfoFormData,
          merchantId,
        }).then(() => {
          if (successCallback) {
            successCallback();
          }
        });
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      className,
      baseInfoFormData,
      submitting,
      submitLeftExtraActions,
      submitRightExtraActions,
      cardTitle,
      submitText,
      loading,
      type,
    } = this.props;

    const { excelFileUrl } = this.state;
    this.baseInfoDocForValidator = excelFileUrl;

    const uploadDocProps = {
      showUploadList: { showRemoveIcon: type !== 'query' },
      onRemove: () => {
        this.setState({
          excelFileUrl: [],
          excelFile: null,
        });
        this.baseInfoDocForValidator = [];
      },
      beforeUpload: file => {
        this.setState({
          excelFileUrl: [file.name],
          excelFile: file,
        });

        this.baseInfoDocForValidator = [file.name];
        return false;
      },
      fileList: excelFileUrl.map((url, uid) => ({
        uid,
        url,
        name: url,
      })),
    };

    const uploadApi = urlCollect.fileUpload;
    const uploadField = 'files[]';
    const uploadParam = { type: 'jssdk' };
    const description = '小于1M，支持jpg、png、jpeg格式';

    return (
      <Card
        bordered={false}
        className={`${styles.root} ${className}`}
        title={cardTitle}
        loading={loading}
      >
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="商户基础资料">
            {getFieldDecorator('excelFileUrl', {
              rules: [
                { required: true, message: ' ' },
                {
                  validator: (rule, value, callback) => {
                    if (this.baseInfoDocForValidator.length === 0) {
                      callback('请上传商户基础资料');
                    }

                    callback();
                  },
                },
              ],
              initialValue: getInitialValue('excelFileUrl', baseInfoFormData),
            })(
              <Upload {...uploadDocProps}>
                {type !== 'query' && (
                  <Button type="primary" ghost>
                    上传文档
                  </Button>
                )}
              </Upload>
            )}
          </FormItem>

          <FormItem {...formItemLayout} label="经营许可证">
            {getFieldDecorator('operationLicenseUrl', {
              rules: [{ required: true, message: '请上传经营许可证' }],
              initialValue: getInitialValue('operationLicenseUrl', baseInfoFormData),
            })(
              <UploadImage
                uploadApi={uploadApi}
                uploadField={uploadField}
                uploadParam={uploadParam}
                type={type === 'query' ? 'render' : 'edit'}
                maxLength={1}
                imgMaxSize={1}
                description={description}
                initialValue={getInitialValue('operationLicenseUrl', baseInfoFormData)}
              />
            )}
          </FormItem>

          <FormItem {...formItemLayout} label="特殊资质证明">
            {getFieldDecorator('specificAptitudeUrl', {
              rules: [{ required: true, message: '请上传特殊资质证明' }],
              initialValue: getInitialValue('specificAptitudeUrl', baseInfoFormData),
            })(
              <UploadImage
                uploadApi={uploadApi}
                uploadField={uploadField}
                uploadParam={uploadParam}
                type={type === 'query' ? 'render' : 'edit'}
                maxLength={1}
                imgMaxSize={1}
                description={description}
                initialValue={getInitialValue('specificAptitudeUrl', baseInfoFormData)}
              />
            )}
          </FormItem>

          <FormItem {...formItemLayout} label="办学许可证">
            {getFieldDecorator('schoolLicenseUrl', {
              rules: [{ required: true, message: '请上传办学许可证' }],
              initialValue: getInitialValue('schoolLicenseUrl', baseInfoFormData),
            })(
              <UploadImage
                uploadApi={uploadApi}
                uploadField={uploadField}
                uploadParam={uploadParam}
                type={type === 'query' ? 'render' : 'edit'}
                maxLength={1}
                imgMaxSize={1}
                description={description}
                initialValue={getInitialValue('schoolLicenseUrl', baseInfoFormData)}
              />
            )}
          </FormItem>

          <FormItem {...formItemLayout} label="营业执照">
            {getFieldDecorator('businessLicenseUrl', {
              rules: [{ required: true, message: '请上传营业执照' }],
              initialValue: getInitialValue('businessLicenseUrl', baseInfoFormData),
            })(
              <UploadImage
                uploadApi={uploadApi}
                uploadField={uploadField}
                uploadParam={uploadParam}
                type={type === 'query' ? 'render' : 'edit'}
                maxLength={1}
                imgMaxSize={1}
                description={description}
                initialValue={getInitialValue('businessLicenseUrl', baseInfoFormData)}
              />
            )}
          </FormItem>

          <FormItem {...formItemLayout} label="组织机构代码证">
            {getFieldDecorator('organizationCodeCertificateUrl', {
              rules: [{ required: true, message: '请上传组织机构代码证' }],
              initialValue: getInitialValue('organizationCodeCertificateUrl', baseInfoFormData),
            })(
              <UploadImage
                uploadApi={uploadApi}
                uploadField={uploadField}
                uploadParam={uploadParam}
                type={type === 'query' ? 'render' : 'edit'}
                maxLength={1}
                imgMaxSize={1}
                description={description}
                initialValue={getInitialValue('organizationCodeCertificateUrl', baseInfoFormData)}
              />
            )}
          </FormItem>

          <FormItem {...formItemLayout} label="身份证正面">
            {getFieldDecorator('identityFrontUrl', {
              rules: [{ required: true, message: '请上传身份证正面' }],
              initialValue: getInitialValue('identityFrontUrl', baseInfoFormData),
            })(
              <UploadImage
                uploadApi={uploadApi}
                uploadField={uploadField}
                uploadParam={uploadParam}
                type={type === 'query' ? 'render' : 'edit'}
                maxLength={1}
                imgMaxSize={1}
                description={description}
                initialValue={getInitialValue('identityFrontUrl', baseInfoFormData)}
              />
            )}
          </FormItem>

          <FormItem {...formItemLayout} label="身份证反面">
            {getFieldDecorator('identityReverseUrl', {
              rules: [{ required: true, message: '请上传身份证反面' }],
              initialValue: getInitialValue('identityReverseUrl', baseInfoFormData),
            })(
              <UploadImage
                uploadApi={uploadApi}
                uploadField={uploadField}
                uploadParam={uploadParam}
                type={type === 'query' ? 'render' : 'edit'}
                maxLength={1}
                imgMaxSize={1}
                description={description}
                initialValue={getInitialValue('identityReverseUrl', baseInfoFormData)}
              />
            )}
          </FormItem>

          {type !== 'query' && (
            <FormItem className="operation-button-wrap">
              {submitLeftExtraActions}
              <Button type="primary" htmlType="submit" loading={submitting}>
                {submitText}
              </Button>
              {submitRightExtraActions}
            </FormItem>
          )}
        </Form>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/Merchant/components/BaseInfo/Index.js